import { render, staticRenderFns } from "./RejectionStats.vue?vue&type=template&id=bb340f62&"
import script from "./RejectionStats.vue?vue&type=script&lang=js&"
export * from "./RejectionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports